var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCartOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.629,
    height: 30,
    viewBox: "0 0 33.629 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(22319.5 1760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart_1_",
    "data-name": "shopping-cart (1)",
    transform: "translate(-22319.5 -1787.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(8.577 51.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(20.013 51.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173",
    transform: "translate(0 27.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17441",
    "data-name": "Rectangle 17441",
    width: 5.695,
    height: 2.848,
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175",
    transform: "translate(4.272 27.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8594",
    "data-name": "Path 8594",
    d: "M67.687,32.789l-.829-5.7H65.429l-1.429.2,3.044,21.159H86.368l6.989-15.663H67.687ZM84.51,45.6H69.531L68.1,35.637H88.955Z",
    transform: "translate(-64 -27.094)",
    fill: "#dc3a1a"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9060",
    "data-name": "Path 9060",
    d: "M-22311.334-1752h21.168l.416.5-4.75,10.5h-16.166Z",
    fill: "#dc3a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartOrange);
export default __webpack_public_path__ + "static/media/shopping_cart_orange.0c67f3b0f9e264609f19532eb7044bda.svg";
export { ForwardRef as ReactComponent };